import * as Fetch from '@/helpers/fetch'

export const getConfigurationsMaMode = async (appName: string): Promise<Fetch.HttpResponse> => {
  const url = `${process.env.VUE_APP_MA_MODE_BFF_URL}/v1/configurations?app_name=${appName}`
  try {
    return await Fetch.get(url)
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}